module.exports = __webpack_public_path__ + "static/img/image_charge.0272fa9c.png";